import { Dropdown } from 'react-bootstrap';
import ArrowDown from '../assets/images/arrow_down.svg';
import { useState } from 'react';

const { Toggle, Menu, Item } = Dropdown;

export const CustomDropDown = ({
  style = {},
  isOpen,
  setIsOpen,
  handleClick,
  show = false,
  options = [],
  onToggle = null,
  className = '',
  selectedValue = '',
  optionsAsImages = false,
  dropdownButtonClassName = '',
  menuStyle = { minWidth: '100%' },
  dropdownButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}) => {
  const normalizeFont = (font) => font.replace(/['"]/g, ''); // Remove quotes
  const defaultFont = options.find((option) => option.label === 'Inter') || options[0]; // Fallback to 'Lora' or first font in list
  const selected =
    options.find((option) => normalizeFont(option.value) === normalizeFont(selectedValue)) ||
    defaultFont;

  return (
    <div className=''>
      <Dropdown
        className={`custom-dropdown customized-dropdown ${className} ${dropdownButtonClassName}`}
        onToggle={(isOpen) => {
          setIsOpen(isOpen);
        }}
      >
        <Toggle
          className={`custom-dropdown-button customized-dropdown-button`}
          id='dropdown-basic'
        >
          <div style={{ ...dropdownButtonStyle, fontFamily: selected.value }}>
            {selected?.label && (
              <p style={{ color: 'black', margin: '0px 5px' }}>{selected.label}</p>
            )}
            {selected?.imageUrl && <img src={selected.imageUrl} alt={selected?.value} />}
            {/* <img src={ArrowDown} alt='' />
             */}

            <img
              src={ArrowDown}
              alt='Toggle Arrow'
              className={`arrow-icon-font ${isOpen ? 'rotate-up-font' : 'rotate-down-font'}`}
            />
          </div>
        </Toggle>

        <Menu style={{ ...menuStyle }}>
          <div style={{ display: optionsAsImages ? 'flex' : 'block' }}>
            {options.map((val, index) => (
              <Item
                as='button'
                key={index}
                onClick={() => {
                  handleClick(val);
                }}
                className={selected?.value === val.value ? 'active' : ''}
                style={{
                  ...style,
                  color: 'black',
                  borderBottom: val.borderBottom ? '1px solid #F0F0EF' : '',
                  fontFamily: defaultFont.label,
                }}
              >
                {val.label ? (
                  val.label
                ) : (
                  <img src={val.imageUrl} alt={val.value} width={30} height={30} />
                )}
              </Item>
            ))}
          </div>
        </Menu>
      </Dropdown>
    </div>
  );
};
